import React from 'react'
import menu from '../assets/menu.png';
import cross from '../assets/close.png'
import { Link } from 'react-router-dom';
import adcodelogo from '../assets/Point_program_adcode_logo.png';

function Navbar() {

  const openNav = () => {
    const sidebar = document.getElementById("menu").style;
    sidebar.width = "80%";
    sidebar.borderWidth = "1px";
    sidebar.borderStyle = "solid";
    sidebar.borderColor = "rgb(0, 82, 82)";

  }
  const closeNav = () => {
    const sidebar = document.getElementById("menu").style;
    sidebar.width = "0%";
    sidebar.borderWidth = "0px";
  }

  return (
    <div className='NavigationBar'>
      <div className="cursor-pointer "  >
        <Link to="/" className='link ' id='logo'>
            <img className='image-logo' src={adcodelogo} alt="LOGO" width={30} />

          ADcode

        </Link>
      </div>
      <div id='NavbarMembers'>
        <ul className="ul" >
          <li id="li1">
            <Link to="/home" className='forNavbarMembers cursor-pointer '>Home</Link>
          </li>
          <li id="li2">
            <Link to="/about" className='forNavbarMembers cursor-pointer '>About</Link></li>
          <li id="li3">
            <Link to="/project" className='forNavbarMembers cursor-pointer '>Project</Link>
          </li>
        </ul>
      </div>

      <div className='menudrawer'>
        <img id="menuimage" className='menuopener background-border-for-menus' src={menu} alt="Menu" onClick={openNav} />
        <div className='menus' id='menu'>
          <ul className='menuUL'>
            <img id="crossimage" className='closebtn background-border-for-menus' src={cross} alt="Close" onClick={closeNav} />
            <li id="li1">
              <Link to="/home" className='forNavbarMembers cursor-pointer '>Home</Link>
            </li>
            <li id="li2">
              <Link to="/about" className='forNavbarMembers cursor-pointer '>About</Link></li>
            <li id="li3">
              <Link to="/project" className='forNavbarMembers cursor-pointer '>Project</Link>
            </li>
          </ul>
        </div>
      </div>


    </div>
  )
}

export default Navbar;
